module.exports = __webpack_public_path__ + "img/cat-yellow.8fb6ad41.svg";